module.exports = __webpack_public_path__ + "static/img/11areaB_07.80a54ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_07.png
// module id = 1087
// module chunks = 1